import { ComponentPropsWithRef } from 'react';
import Drawer from '../container/Drawer';

type Props = Omit<ComponentPropsWithRef<typeof Drawer>, 'actions' | 'size' | 'variant'>;

const NavigationDrawer: React.FC<Props> = ({ ...rest }) => <Drawer size="sm" variant="neutral" {...rest} />;

export default NavigationDrawer;
